<template>
  <v-container align-top justify-center class="livefeed">
      <v-layout row wrap align-bottom justify-center>
        <v-flex xs12>
            <v-card-title primary-title>
            <span class="subheading font-weight-bold">
            Please enter the URL/domain that you wish to get the reputation for:
            </span>
            </v-card-title>
        </v-flex>

        <v-layout row wrap justify-center>

	<v-combobox
          :loading="suggest_loading"
          :items="suggest_data"
          :search-input.sync="suggestion"
          v-model="token"
          cache-items
          @keyup.enter="getReputation"
          class="mx-3"
          ref="suggest_combobox"
          flat
          hide-details
          clearable
          dense
          menu-props="closeOnContentClick, closeOnClick"
          label="Enter token to get reputation for (Start typing for suggestions)"
          solo-inverted
          @input="getReputation"
        ></v-combobox>

            <v-btn flat color="blue" :disabled="!has_data"
                @click="getReputation">
                <span class="mr-2">Get Reputation</span>
            </v-btn>
         </v-layout>

         <v-flex xs12>
             <v-card-text v-if="token"><span
             class="font-weight-bold">{{api_status}}</span> "{{token}}"
             </v-card-text>
         </v-flex>

         <v-flex xs12>
           <div v-if="reputation_data">
               <v-divider></v-divider>
               <!-- <v-card-title> <span class="font-weight-bold">Reputation is:</span> </v-card-title>
               <v-card-text v-if="reputation_data"> {{reputation_data}}
               </v-card-text> -->

               <v-expansion-panel
                v-model="verdicts_panel"
                expand >

                 <v-expansion-panel-content
                    v-for="verdict in verdicts"
                    :key="verdict.title"
                    inset
                  >
                  <div slot="header" class="body-2">
                      <span class="body-2">
                      {{verdict.title}}
                      </span>

                  </div>
                    <v-list dense>
                      <v-list-tile
                            v-for="(item, index) in verdict.items"
                            :key="index"
                            @click=""
                        >

                            <v-subheader
                              v-if="item.header"
                              :key="index"
                              class="pl-4" >
                                <span>{{item.title}} {{item.value}}</span>
                            </v-subheader>

                            <v-divider v-else-if="item.divider && index !=
                                       Object.keys(verdict.items).length - 1"
                                :key="index"
                                :inset="item.inset"
                                >
                            </v-divider>

                            <!-- <v-list-tile-content v-else
                                inset
                                :class="get_alert_color(item)" > -->
                                <!-- <v-list-tile-sub-title inset > -->
                                <div class="py-0 pl-3 body-1 font-weight-light" v-else>
                                    <v-card-text :inset="item.inset"
                                    :class="get_alert_color(item)">
                                      <span class="body-1 font-weight-light">
                                  {{item.title}} {{item.value}} </span>
                                    </v-card-text>
                                </div>
                        <!-- </v-list-tile-sub-title> -->
                        <!-- </v-list-tile-content> -->
                        </v-list-tile>
                       </v-list>

                    </v-expansion-panel-content>
                </v-expansion-panel>
           </div>

         </v-flex>
      </v-layout>
     </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

import { mapActions } from 'vuex';
import moment from 'moment';

export default {

  name: 'livefeed',
  data() {
    return {
      msg: 'Test',
      token: null,
      reputation: null,
      suggestion: null,
      suggest_data: [],
      suggest_loading: false,
      token1: null,
      service: 'livefeed',
      api_status: 'Will get reputation for: ',
      verdicts_panel: [true, false, false],
      verdicts: [
        {
          title: 'Reputation',
          action: 'token_reputation',
          active: true,
          items: [
            { id: 'is_phish', title: 'Is Phish Token:', value: null },
            { id: 'is_malware', title: 'Is Malware Token:', value: null },
            { id: 'date_added', title: 'Date Added:', value: null },
            { id: 'date_updated', title: 'Date Updated:', value: null },
          ],
        },

        {
          title: 'Category',
          active: true,
          action: 'token_category',
          items: [
            { id: 'category', title: '', value: 'No Data' },
          ],
        },

        {
          title: 'Spam Reputation',
          active: true,
          action: 'token_spam_reputation',
          items: [
            { id: 'spam_reputation', title: '', value: 'No Data' },
          ],
        },
      ],

    };
  },
  watch: {
    token() {
      if (!this.token) {
        this.reputation = null;
        this.api_status = 'Will get reputation for: ';
      }
    },

    suggestion(query) {
      if (query) {
        this.suggestURL(query);
      }
    },

    reputation() {
      if (this.reputation && this.reputation === 'No data found') {
        this.reset_verdicts();
      } else if (this.reputation) {
        this.update_verdicts_data();
      } else {
        this.reset_verdicts();
      }
    },
  },

  computed: {
    has_data() {
      return !!this.token;
    },

    reputation_data() {
      if (this.reputation) {
        return JSON.stringify(this.reputation, null, 3);
      }
      return '';
    },

  },
  methods: {
    update_verdicts(items, key, val, field = 'value') {
      items.find(item => item.id === key)[field] = val;
    },

    reset_verdicts() {
      // TODO: items is pos, not actual item we are looking for..fix
      const items = this.verdicts.find(verdict => verdict.title === 'Reputation').items;
      this.reset_reputation_verdicts(items);

      for (const i in this.verdicts) {
        const verdict = this.verdicts[i];
        if (verdict.title !== 'Reputation') {
          verdict.items = [];
          verdict.items.push({
            id: verdict.title,
            title: '',
            value:
                    'No Data',
          });
        }
      }
    },

    update_verdicts_data() {
      this.update_reputation_verdicts();
      this.update_category_verdicts();
    },

    reset_reputation_verdicts(items) {
      this.update_verdicts(items, 'is_phish', 'No Data');
      this.update_verdicts(items, 'is_malware', 'No Data');
      this.update_verdicts(items, 'date_added', 'No Data');
      this.update_verdicts(items, 'date_updated', 'No data');
    },

    update_category_verdicts() {
      if (this.reputation.livefeed && this.reputation.livefeed.categories) {
        const categories = this.reputation.livefeed.categories;
        const verdict = this.verdicts.find(verdict => verdict.title === 'Category');

        verdict.items = [];
        let item_id = '';
        let index = 0;
        for (const url_path in categories) {
          // the classification applies to the entire URL, and not
          // to some domain/subdomain component.
          const categorization_level = url_path === 'noFurl'
            ? 'Entire URL' : url_path;

          verdict.items.push({
            header: true,
            title: 'Categorization Level:',
            value: categorization_level,
          });

          for (const i in categories[url_path]) {
            const category_info = categories[url_path][i];
            item_id = url_path + index;
            index += 1;
            verdict.items.push({
              id: item_id,
              title:
                        'Category:',
              inset: true,
              value: `${category_info.category}, Language: ${
                category_info.language}`,
            });

            // verdict.items.push({'id': item_id + 'lan', 'inset': true,
            //    'title': 'Language:', 'value': category_info.language})
            // verdict.items.push({'id': 'divider' + index,
            //    'divider': true, 'inset': true})
          }
        }
      }
    },

    update_reputation_verdicts() {
      const items = this.verdicts.find(verdict => verdict.title
            === 'Reputation').items;

      this.update_verdicts(items, 'is_phish',
        this.reputation.is_phish ? 'Yes' : 'No');
      this.update_verdicts(items, 'is_malware',
        this.reputation.is_malware ? 'Yes' : 'No');

      let date_added = (this.reputation.dateAdded
            && this.reputation.dateAdded.v)
        ? moment(this.reputation.dateAdded.v).format('LLL') : '';

      // there is a typo (that may be corrected) in the field name for
      // dateAdded (it was named dataAdded)
      if (!date_added) {
        date_added = (this.reputation.dataAdded
            && this.reputation.dataAdded.v)
          ? moment(this.reputation.dataAdded.v).format('LLL') : '';
      }

      this.update_verdicts(items, 'date_added', date_added);
      this.update_verdicts(items, 'date_updated',
        this.reputation.dateUpdated && this.reputation.dateUpdated.v
          ? moment(this.reputation.dateUpdated.v).format('LLL') : '');
    },

    suggestURL(query) {
      if (this.suggest_loading) {
        return;
      }

      this.suggest_loading = true;

      const payload = { service: this.service, q: query };
      this.api_suggest(payload).then((resp) => {
        this.suggest_data = resp.data && resp.data.suggest && resp.data.suggest.suggestions
          ? resp.data.suggest.suggestions[0].options.map(item => item._source.url) : [];

        // console.log(this.suggest_data);
      }).catch((err) => {
        console.error(`Unable to suggest items for ${query} because
            ${err}`);
        this.suggest_data = [];
      }).finally(() => { this.suggest_loading = false; });
    },

    getReputation() {
      // close the suggestions box once a request is in progress...
      this.$refs.suggest_combobox.isMenuActive = false;

      // console.log(`Get reputation for ${this.token}`);
      this.api_status = 'Getting Reputation for: ';
      const payload = { service: this.service, id: this.token };
      this.api_get(payload).then((resp) => {
        // console.log(JSON.stringify(resp))
        if (resp.data && resp.data.data && resp.data.data.attributes) {
          this.reputation = resp.data.data.attributes;
        } else {
          this.reputation = 'No data found';
        }

        this.api_status = 'Reputation for: ';
      }).catch((err) => {
        console.error(`Unable to get reputation for ${this.token
        } because ${err}`);
        this.reputation = null;
        this.api_status = 'Error encountered while getting reputation for: ';
      });
    },

    get_alert_color(item) {
      if (item.id in { is_phish: 1, is_malware: 1 } && item.value === 'Yes') {
        return 'danger';
      } if (item.id in { is_phish: 1, is_malware: 1 } && item.value === 'No') {
        return 'ok';
      }
      return '';
    },

    ...mapActions([
      'api_get',
      'api_suggest',
    ]),

  },
  // components: {
  //  HelloWorld,
  // },
};
</script>

<style>
 .danger {
    color: red;
 }

 .ok {
    color: green;
 }

</style>
